import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import bg from 'images/personas/bg-getting-more-specific.jpg'
import LimitedViewText from './LimitedViewText'

const GettingMoreSpecific = ({
  limitedView,
  photo,
  professionInterests
}) => {
  const artist_interest = limitedView ? [] : professionInterests.top5_Artist.slice(0,3).map(interest => interest.name);
  const executive_interest = limitedView ? [] : professionInterests.top5_Executive.slice(0,3).map(interest => interest.name);
  const sales_marketing_interest = limitedView ? [] : professionInterests['top5_Sales/Marketing/PR'].slice(0,3).map(interest => interest.name);
  const limitedViewTable = (
    <>
      <td>
        <LimitedViewText short />
      </td>

      <td>
        <LimitedViewText short />
      </td>

      <td>
        <LimitedViewText short />
      </td>
    </>
  )

  const content = (
    <React.Fragment>
      <div className="image-layer image-layer--black bg-center bg-cover bg-no-repeat relative" style={{ backgroundImage: `url('${photo[0].url}')` }}>
        <h2 className="persona-sub-title p4 relative sm-p3 text-white z1">Getting<br /> more specific</h2>
      </div>

      <div className="p4 sm-px0 sm-py3">
        <div className="flex flex-wrap mxn2">
          <div className="col-5 pdf-col-12 pdf-mb3 px2 sm-col-12 sm-mb3">
            <p className="h2 x-lg-h3">
              As you narrow down your audience, it is important to note how their interests change according to their professions.
            </p>
          </div>

          <div className="col-7 pdf-col-12 px2 sm-col-12">
            <div className="table-outer-container">
              <div className="table-container">
                <table className="persona-table pdf-getting-more-table-max-width">
                  <tbody>
                    <tr>
                      <th>Profession</th>
                      <th>Topic of interest</th>
                      <th>Topic of interest</th>
                      <th>Topic of interest</th>
                    </tr>

                    <tr>
                      <td>artists</td>
                      {limitedView
                        ? limitedViewTable
                        : artist_interest.map(item => (
                          <td key={item}>{item}</td>
                        ))
                      }
                    </tr>

                    <tr>
                      <td>executives</td>
                      {limitedView
                        ? limitedViewTable
                        : executive_interest.map(item => (
                          <td key={item}>{item}</td>
                        ))
                      }
                    </tr>

                    <tr>
                      <td>sales & marketing</td>
                      {limitedView
                        ? limitedViewTable
                        : sales_marketing_interest.map(item => (
                          <td key={item}>{item}</td>
                        ))
                      }
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="profession_interests">
        <div className="slider-box slider-box--sm-p0 slider-box--pdf-p0 bg-white box-shadow-box">
          <div className="sm-py3">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default GettingMoreSpecific
